export function addAlpha(color, opacity) {
    const boundOpacity = Math.round(Math.min(Math.max(opacity || 1, 0), 1) * 255);
    return color + boundOpacity.toString(16).toUpperCase();
}
//# sourceMappingURL=utils.js.map